import { Trans, useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type DeleteTimeLogSuccessModalProps = {
  open: boolean
  handleClose: VoidFunction
  employeeName: string
}

export function DeleteTimeLogSuccessModal({
  open,
  handleClose,
  employeeName
}: Readonly<DeleteTimeLogSuccessModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose}>
      <AcknowledgeModal
        result="positive"
        title={t('dialog.volunteering.deleteTimeLog.success.title')}
        description={
          <Trans
            i18nKey="dialog.volunteering.deleteTimeLog.success.description"
            components={{ b: <b /> }}
            values={{ employeeName }}
          />
        }
        buttonText={t('button.close')}
        handleClose={handleClose}
      />
    </Modal>
  )
}
